export default __webpack_public_path__ + "static/media/location-mke.6565106c.jpg";